import * as gqlTypes from "@hydrologiq/gql/graphql"
import { useState, useEffect } from "react"
import { ButtonProps } from "@chakra-ui/react"
import { ScheduleActivityButton } from "@hydrologiq/shared/content/components/Button"
import React from "react"
import ActivityManage from "./ActivityManage"

interface OrderEventCreateProps {
  order?: gqlTypes.Order
  asset?: gqlTypes.Asset
  activities: gqlTypes.Activity[]
  disabled?: boolean
  buttonProps?: ButtonProps
  onOpenDialog?: () => void
  openOverride?: boolean
  onOpenChange?: (isOpen: boolean) => void
  trigger?: React.ReactNode | React.ReactNode[]
  onActivityCreated?: () => void
  activityKinds?: gqlTypes.ActivityKind[]
  allowAnyAsset?: boolean
  defaultStartDate?: string
}

const ActivityCreate = (props: OrderEventCreateProps) => {
  const {
    order,
    asset,
    activities,
    activityKinds,
    disabled = false,
    onOpenDialog,
    openOverride = false,
    onOpenChange,
    trigger,
    onActivityCreated,
    allowAnyAsset,
    defaultStartDate,
  } = props
  const [open, setOpen] = useState(openOverride)

  useEffect(() => {
    if (openOverride) {
      setOpen(openOverride)
    }
  }, [openOverride])

  useEffect(() => {
    if (onOpenDialog && open) {
      onOpenDialog()
    }
    if (onOpenChange) {
      onOpenChange(open)
    }
  }, [onOpenDialog, open, onOpenChange])

  const handleClose = () => {
    setOpen(false)
    if (onOpenChange) {
      onOpenChange(false)
    }
  }

  return (
    <ActivityManage
      mode="create"
      order={order}
      asset={asset}
      activities={activities}
      activityKinds={activityKinds}
      allowAnyAsset={allowAnyAsset}
      defaultStartDate={defaultStartDate}
      onActivityCreated={onActivityCreated}
      isOpen={open}
      onClose={handleClose}
      trigger={
        trigger ? trigger : <ScheduleActivityButton mt={2} disabled={disabled} description="Schedule an activity" />
      }
    />
  )
}

export default ActivityCreate
